import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';
interface TabContainerProps {
  $active: boolean;
}
export const Label = styled.span`
  font-size: 14px;
  font-weight: 600;
`;

export const Icon = styled.div`
  height: 16px;
  width: 16px;
  margin-right: 5px;
`;

export const TabContainer: any = styled.div<TabContainerProps>`
  padding: 10px 14px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  background: ${({ $active }) =>
    $active
      ? `linear-gradient(99deg, rgb(${ColorPalette.RGB.AtomicTangerine}), rgb(${ColorPalette.RGB.RedPigment2}))`
      : ColorPalette.HEX.AntiFlashWhite2};
  margin-right: 1px;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;

  & ${Label} {
    color: ${({ $active }) => ($active ? ColorPalette.HEX.White : ColorPalette.HEX.PhilippineSilver)};
  }

  & ${Icon} {
    color: ${({ $active }) => ($active ? ColorPalette.HEX.White : ColorPalette.HEX.PhilippineSilver)};
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: row;
`;
